<template>
  <div>
    <div class="content-header row">
      <div class="content-header-left col-12 mb-2 mt-1">
        <div class="row breadcrumbs-top">
          <div class="col-12">
            <div class="card">
              <div class="card-content">
                <div
                  class="modal fade text-left"
                  id="reset-password-modal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="create-modal-title"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content resetPasswordPopup">
                      <div class="modal-header">
                        <h3 class="modal-title resetPasswordHeading" id="create-modal-title">
                          {{ $t('user_edit_module_reset_password_popup_heading') }}</h3>
                        <button
                          type="button"
                          class="close rounded-pill"
                          data-dismiss="modal"
                          aria-label="Close"
                          @click="dialogueClose()"
                        >
                          <img :src="closeImage" alt="Close image"/>
                        </button>
                      </div>
                      <div class="modal-body">
                        <Alert :text="$t('user_edit_module_reset_password_popup_required_error')" type="danger"
                               dismissable="false" v-if="requiredError"/>
                        <Alert :text="$t('pacto_users_module_validation_email_error')" type="danger" dismissable="false"
                               v-if="modalEmailError"/>
                        <Alert :text="resetPasswordErrorText" type="danger" dismissable="false" v-if="passwordError"/>
                        <Alert :text="$t('user_edit_module_reset_password_popup_compare_password_error')" type="danger"
                               dismbissable="false" v-if="comparePasswordError"/>
                        <Alert :text="$t('user_edit_module_reset_password_popup_password_error')" type="danger"
                               dismbissable="false" v-if="requiredPasswordError"/>
                        <form action="">
                          <div class="form-group row">
                            <div class="col-md-12 col-sm-12">
                              <input
                                type="text"
                                class="form-control inputHeight"
                                :placeholder="$t('user_edit_module_reset_password_popup_email_placeholder')"
                                @keyup="modalEmailCheck"
                                v-model="modalEmail"

                              />
                            </div>
                          </div>
                          <div class="form-group row">
                            <div class="col-md-12 col-sm-12">
                              <input
                                type="password"
                                class="form-control inputHeight"
                                :placeholder="$t('user_edit_module_reset_password_popup_new_password_placeholder')"
                                @keyup="passwordCheck"
                                v-model="modalPassword"
                              />
                            </div>
                          </div>
                          <p class="passwordTitle">
                            ({{ $t('user_edit_module_reset_password_popup_validation_p_tag') }})</p>
                          <div class="form-group row">
                            <div class="col-md-12 col-sm-12">
                              <input
                                type="password"
                                class="form-control inputHeight"
                                :placeholder="$t('user_edit_module_reset_password_popup_renter_password_placeholder')"
                                @keyup="comparePassword"
                                v-model="modalPasswordConfirm"
                              />
                            </div>
                          </div>
                        </form>
                      </div>
                      <div class="modal-footer modalFooter">
                        <button type="button" class="btn btn-light-secondary"
                                data-dismiss="modal"
                                aria-label="Close">
                          <em class="bx bx-x d-block d-sm-none"></em>
                          <span class="d-none d-sm-block " style="color: white">{{
                              $t('user_edit_module_reset_password_popup_cancel_button')
                            }}</span>
                        </button>
                        <button type="button" class="btn btn-primary ml-1">
                          <em class="bx bx-check d-block d-sm-none"></em>
                          <span class="d-none d-sm-block" @click="submitPassword()">{{
                              $t('user_edit_module_reset_password_popup_submit_button')
                            }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <!--              reset password confirmation modal -->
                <div
                  class="modal fade text-left"
                  id="reset-password-confirm-modal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="create-modal-title"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-lg" role="document">
                    <div class="modal-content resetPasswordDialogue">
                      <div class="modal-header">
                        <h3 class="modal-title resetPasswordHeading" id="create-modal-title">{{
                            $t('user_edit_module_reset_password_confirmation_popup_heading')
                          }}</h3>
                        <button
                          type="button"
                          class="close rounded-pill"
                          data-dismiss="modal"
                          aria-label="Close"

                        >
                          <img :src="closeImage" alt="Close image"/>
                        </button>
                      </div>
                      <div class="modal-body">

                        <h3 class="modal-title resetPasswordSuccessHeading" id="create-modal-title">
                          {{ $t('user_edit_module_reset_password_confirmation_popup_message') }}</h3>
                      </div>
                      <div class="modal-footer modalFooter">

                        <button type="button" class="btn btn-light-secondary"
                                data-dismiss="modal"
                                aria-label="Close">
                          <em class="bx bx-x d-block d-sm-none"></em>
                          <span class="d-none d-sm-block " style="color: white">{{
                              $t('user_edit_module_reset_password_confirmation_popup_cancel_button')
                            }}</span>
                        </button>
                        <button type="button" class="btn btn-primary ml-1" data-dismiss="modal"
                                aria-label="Close">
                          <em class="bx bx-check d-block d-sm-none"></em>
                          <span class="d-none d-sm-block" @click="submitPassword()">{{
                              $t('user_edit_module_reset_password_confirmation_popup_ok_button')
                            }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <!--user edit confirmation modal-->
                <div
                  class="modal fade text-left"
                  id="user-edit-success-modal"
                  tabindex="-1"
                  role="dialog"
                  aria-labelledby="create-modal-title"
                  aria-hidden="true"
                >
                  <div class="modal-dialog modal-lg modalPopStyle" role="document">
                    <div class="modal-content resetPasswordDialogue">
                      <div class="modal-header ">
                        <h3 class="modal-title resetPasswordHeading " id="create-modal-title">
                          {{ $t('users_edit_module_confirmation_popup_heading') }}</h3>
                        <button
                          type="button"
                          class="close rounded-pill"
                          data-dismiss="modal"
                          aria-label="Close"

                        >
                          <img :src="closeImage" alt="Close image"/>
                        </button>
                      </div>
                      <div class="modal-body">

                        <h3 class="modal-title resetPasswordSuccessHeading divStyleModall" id="create-modal-title">"{{
                            $t('users_edit_module_confirmation_popup_message')
                          }}”</h3>
                      </div>
                      <div class="modal-footer modalFooter">

                        <button type="button" class="btn btn-primary ml-1 okButtonStyle" data-dismiss="modal"

                                aria-label="Close">
                          <em class="bx bx-check d-block d-sm-none"></em>
                          <span class="d-none d-sm-block"
                                @click="routeTo()">{{ $t('users_edit_module_confirmation_popup_ok_button') }}</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="card-header headerAlign">
                  <div>
                  <span style="display: inline-block; cursor: pointer" @click="Editclose()">
                  <img :src="backIcon" class="titleFont" alt="Back icon"/>
                  <h5 style="display: inline-block; transform: translate(23px, -20px);"
                      class="backFont "> {{ $t('user_edit_module_back_button') }} </h5>
                    </span>
                    <h5 class="card-title headingAlign">{{ $t('user_edit_module_heading') }} </h5>
                  </div>
                  <button type="button" class="btn btn-light-secondary resetPasswordStyle">
                    <em class="bx bx-x d-block d-sm-none"></em>
                    <span class="d-none d-sm-block " style="color: white"
                          @click="resetPasswordModal()">{{ $t('user_edit_module_reset_password_button') }}</span>
                  </button>
                </div>
                <div class="card-body card-dashboard">
                  <Alert :text="$t('users_edit_module_reset_password_validation_required_error')" type="danger"
                         dismissable="false" v-if="requiredAllError"/>
                  <Alert :text="apiErrorText" type="danger" dismissable="false" v-if="apiErrorText !=''"/>
                  <form @submit.prevent="handleSubmit">
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('users_edit_module_label_firstname') }} <span
                          class="madatoryStar">*</span></label>
                        <input
                          type="text"
                          class="form-control inputTab"
                          v-model="target.firstName"
                          :class="{ 'is-invalid': isSubmitted && v$.target.firstName.$error }"
                        />
                        <div v-if="isSubmitted && !v$.target.firstName.required" class="text-danger">{{
                            $t('users_edit_module_name_validation')
                          }}
                        </div>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('users_edit_module_label_lastname') }} <span
                          class="madatoryStar">*</span></label>
                        <input type="text" class="form-control inputTab" v-model="target.lastName"/>
                      </div>
                    </div>

                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('users_edit_module_label_role') }} <span class="madatoryStar">*</span></label>
                        <select class="form-control inputTab" v-model="target.type">
                          <option selected value="superadmin">{{
                              $t('users_edit_module_role_dropdown_super_admin')
                            }}
                          </option>
                          <option value="regionaladmin">{{
                              $t('users_edit_module_role_dropdown_regional_admin')
                            }}
                          </option>
                          <option value="countryadmin">{{
                              $t('users_edit_module_role_dropdown_country_admin')
                            }}
                          </option>
                          <option value="pactousersuccesslead">
                            {{ $t('users_edit_module_role_dropdown_user_success_lead') }}
                          </option>
                        </select>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('users_edit_module_label_email') }}</label>
                        <input type="text" class="form-control inputTab" v-model="target.email" disabled/>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('users_edit_module_label_language') }} <span
                          class="madatoryStar">*</span></label>
                        <select class="form-control inputTab" v-model="target.language">
                          <option selected value="en"> {{ $t('users_edit_module_language_dropdown_en') }}</option>
                          <option value="ar"> {{ $t('users_edit_module_language_dropdown_ar') }}</option>
                          <option value="es"> {{ $t('users_edit_module_language_dropdown_es') }}</option>
                        </select>
                      </div>
                      <div class="col-md-6 col-sm-12">
                        <label for>{{ $t('users_edit_module_label_phone') }} <span class="madatoryStar">*</span></label>
                        <div class="marginDiv">
                          <!-- <input
                            type="tel"
                            id="phoneNumber"
                            class="form-control inputTabData"
                            v-model="phoneNumber"
                          />
                          <vue-country-code
                            @onSelect="onSelect" class="flagAlign">
                          </vue-country-code> -->
                          <PhoneNumber addClass="form-control inputTabData" :phoneNumber="phoneNumber"
                                       :onPhoneNumberChange="onPhoneNumberChange"/>
                        </div>
                      </div>
                    </div>
                    <div class="form-group row">
                      <div class="col-md-6 col-sm-12 ">
                        <label for>{{ $t('users_edit_module_label_status') }} <span
                          class="madatoryStar">*</span></label>
                        <select class="form-control inputTab" v-model="target.status">
                          <option selected value="joined"> {{ $t('user_edit_module_status_dropdown_active') }}</option>
                          <option value="banned"> {{ $t('user_edit_module_status_dropdown_inactive') }}</option>
                        </select>
                      </div>
                    </div>
                    <div v-if="target.lastEditedBy">
                      <p class="text-muted" style="margin-bottom: 1px">
                        {{ $t('user_edit_module_label_last_edited_by') }}:
                      </p>
                      <p>{{ target.lastEditedBy.name }} {{ $t('on') }}
                        {{ $filters.formatDate(target.lastEditedBy.lastEditedAt) }}</p>
                    </div>
                  </form>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-light-secondary">
                    <em class="bx bx-x d-block d-sm-none"></em>
                    <span class="d-none d-sm-block " style="color: white"
                          @click="Editclose()">{{ $t('users_edit_module_close_button') }}</span>
                  </button>
                  <button type="button" class="btn btn-primary ml-1">
                    <em class="bx bx-check d-block d-sm-none"></em>
                    <span class="d-none d-sm-block"
                          @click="submitChanges()">{{ $t('users_edit_module_save_changes_button') }}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--  Reset password modal-->
</template>

<script>
import PhoneNumber from "../../components/PhoneNumber";
import Alert from "@/components/Alerts";
import {useVuelidate} from '@vuelidate/core'
import {required, email} from '@vuelidate/validators';
import "@/app-assets/css/pages/authentication.css";

export default {
  components: {
    PhoneNumber,
    Alert
  },
  setup() {
    return {v$: useVuelidate()}
  },
  data() {
    return {
      target: {},
      userId: this.$route.params.uid,
      backIcon: require('@/assets/backIcon.png').default,
      emailError: false,
      passwordError: false,
      confirmPasswordError: false,
      comparePasswordError: false,
      error: false,
      requiredPasswordError: false,
      phoneNumber: 0,
      requiredAllError: false,
      data: {},
      lastName: "",
      errorText: "",
      errorMessage: "",
      isSubmitted: false,
      modalEmail: "",
      modalPassword: "",
      modalPasswordConfirm: "",
      resetPasswordErrorText: "",
      submitStatus: false,
      requiredError: false,
      apiErrorText: "",
      dialCode: 0,
      closeImage: require('@/assets/close.png').default,
      modalEmailError: false,

    }
  },
  methods: {

    handleSubmit() {
      this.isSubmitted = true;
      this.v$.$touch();
    },
    modalEmailCheck() {
      let self = this;
      let emailPattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (emailPattern.test(self.modalEmail)) {
        self.modalEmailError = false;
      } else {
        self.modalEmailError = true;
      }
    },
    passwordCheck() {
      let self = this;
      let regularExpression = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{7,}$/;
      if (regularExpression.test(self.modalPassword)) {
        self.requiredPasswordError = false;
      } else {
        this.requiredPasswordError = true;
      }
    },
    comparePassword() {
      let self = this;
      if (self.modalPassword == self.modalPasswordConfirm) {
        self.comparePasswordError = false;
      } else {
        self.comparePasswordError = true;
      }
    },
    resetPasswordModal() {
      this.resetPasswordErrorText = '';
      this.error = false;
      this.requiredPasswordError = false;
      this.modalEmail = "";
      this.modalPassword = "";
      this.modalPasswordConfirm = '';
      $("#reset-password-modal").modal();
    },
    getUserById() {
      let self = this;
      this.$apiCall.get(`/v1/users/${this.userId}`).then((response) => {
        self.target = response.data;
        self.phoneNumber = self.target.phoneNumber;
      });
    },
    onPhoneNumberChange(phoneNumber) {
      this.phoneNumber = phoneNumber;
    },
    Editclose() {
      this.$router.push({name: 'AdminsPage'});
    },

    checkValue() {
      if (/[^a-zA-Z]/.test(this.target.firstName)) {
        this.errorMessage = 'Input value contains other syantax.';
      } else {
        this.errorMessage = '';
      }
    },

    submitChanges() {
      let self = this;
      self.submitting = true;
      if (self.target.firstName == '') {
        self.requiredAllError = true;
      }
      if (self.target.lastName == "") {
        self.requiredAllError = true;
      }
      if (!self.target.phoneNumber == "") {
        self.requiredAllError = true;
      }
      self.requiredAllError = false
      self.data = {
        firstName: self.target.firstName,
        lastName: self.target.lastName,
        type: self.target.type,
        language: self.target.language,
        phoneNumber: self.phoneNumber,
        status: self.target.status
      }
      this.$apiCall.patch(`v1/admins/${this.userId}`, self.data).then((response) => {
        const data = response.data;
        self.submitting = false;
        self.apiErrorText = false;
        $("#user-edit-success-modal").modal();
      })
        .catch((error) => {
          $.unblockUI();
          self.apiErrorText =
            `<strong>Ops!</strong> ${error.response.data.message}`;

        });
    },
    routeTo() {
      this.$router.push({name: 'AdminsPage'})
    },

    submitPassword() {
      let self = this;
      this.submitStatus = true;
      if (!self.comparePasswordError && !self.requiredPasswordError && !self.modalEmailError) {

        this.$apiCall
          .patch(`v1/admins/reset/password/${self.userId}`, {
            email: self.modalEmail,
            newPassword: self.modalPassword,
            language: self.target.language
          })
          .then(function (response) {
            $("#reset-password-modal").modal('toggle');
            $("#reset-password-confirm-modal").modal();
          })
          .catch(function (error) {
            self.passwordError = true;
            self.resetPasswordErrorText =
              `<strong>Ops!</strong> ${error.response.data.message}`;
            self.modalEmail = "";
            self.modalPassword = "";
            self.modalPasswordConfirm = "";
          });
      }
    },

    dialogueClose() {
      let self = this;
      self.requiredPasswordError = false;
      self.confirmPasswordError = false;
      self.comparePasswordError = false;
      self.passwordError = false;
      self.modalEmailError = false;
      self.submitStatus = false;

    }
  },


  mounted() {
    this.getUserById()
  }
}
</script>

<style scoped>
.inputTab {
  height: 3em;
  width: 35em;
}

@media (min-width: 768px) and (max-width: 1366px) {
  .inputTab {
    height: 3em;
    width: 27em;
  }
}

.titleFont {
  text-align: center;
  margin-right: 12%;

}

.headingAlign {
  margin-left: 23em;
  display: inline-block;
  transform: translate(101px, -20px);
}

@media (min-width: 768px) and (max-width: 1366px) {
  .headingAlign {
    margin-left: 23em;
    display: inline-block;
    transform: translate(-145px, -20px);
  }
}

.backFont {
  text-transform: uppercase;
  font-size: 15px;
  font-weight: 500;
}

.headerAlign {
  border-width: 2px;
  height: 6em;
}

.alert {
  padding: 5px 10px;
  border: 1px solid #ff72728a;
  display: inline-block;
  color: #d48888;
  border-radius: 4px;
}

.resetPasswordHeading {
  color: #4A0A1E;
  font-size: 18px !important;
  font-weight: 450 !important;
}

.inputHeight {
  height: 3.5em;
}

.modalPopStyle {
  margin-left: 44em;
  margin-top: 182px;
}

.okButtonStyle {
  width: 8em;
}

.modalFooter {
  border-top: 1px solid #DFE3E7;
}

.resetPasswordSuccessHeading {
  color: #767676;
  font-size: 20px !important;
  font-weight: 400 !important;
  text-align: center;
  margin-top: 4%;
}

.resetPasswordDialogue {
  height: 19em;
  border-radius: 1rem !important;
  margin-top: 35%;
}

.flagAlign {
  transform: translate(-35em, 0px);
  border: 0px;
}

@media (max-width: 1366px) {
  .resetPasswordDialogue {
    height: 19em;
    border-radius: 1rem !important;
    transform: translate(-17em, -46px);
  }

  .flagAlign {
    transform: translate(-27em, 0px);
    border: 0px;
  }
}

.resetPasswordPopup {
  border-radius: 1rem !important;
  margin-top: 17em;
  margin-left: 6em;
}

.passwordTitle {
  white-space: nowrap;
  font-size: 14px;
}

.resetPasswordStyle {
  display: inline-block;
  transform: translate(96em, -56px);
  margin-left: 142px
}

@media (min-width: 768px) and (max-width: 1366px) {
  .resetPasswordStyle {
    display: inline-block;
    transform: translate(45em, -56px);
    margin-left: 142px
  }
}

.inputTabData {
  height: 3em;
  width: 35em;
  border: 1px solid #DFE3E7;
  border-radius: 0.267rem;
}

.marginDiv {
  display: flex;
}

.buttonWidth {
  width: 8em;
}

.madatoryStar {
  color: red;
}

@media (min-width: 768px) and (max-width: 1366px) {
  .inputTabData {
    height: 3em;
    width: 27em;
    border: 1px solid #DFE3E7;
    border-radius: 0.267rem;
  }
}
</style>
